const baseURL = process.env.REACT_APP_API_ENDPOINT;
export const FILES_FOLDER_LIST_URL: string = baseURL + "/fdc-commandops/files";
export const FILE_UPLOAD_URL: string = baseURL + "/fdc-commandops/files/upload";
export const FILE_DOWNLOAD_URL: string =
  baseURL + "/fdc-commandops/files/download-pdf?filePath=";
